export default __webpack_public_path__ + "static/media/medium-face.af5e9121.svg";